import React, { useEffect, useState, useRef } from "react";
import {
  Form,
  Table,
  Button,
  Tag,
  Input,
  Popover,
  Descriptions,
  Space,
} from "antd";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import HighLighter from "react-highlight-words";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { ItemsView } from "./ItemsView";
import { Gallery } from "./Gallery";
import { EditOrder } from "./EditOrder";
import { formatTimestamp, statusList,decrypt,collections,fetchData } from "../../utils";
import { checkAccess } from "../../access";
import { calculateOrder } from "../../utils";

export const OrdersView = () => {

  const [form] = Form.useForm();

  const querydb = getFirestore();

  const mapDocs = (res) => {
    return res.docs.map((ele) => ({ key: ele.id, ...ele.data() }));
  };

  const [data, setData] = useState();
  const [couriers, setCouriers] = useState();
  const [role,setRole] = useState();
  const [openDetail, setOpenDetail] = useState(false);
  const [openReceipt, setOpenReceipt] = useState(false);
  const [openReceiptOrder, setOpenReceiptOrder] = useState(false);
  const [detail, setDetail] = useState([]);
  const [order, setOrder] = useState();
  const [receipts, setReceipts] = useState();
  const [receiptOrder, setReceiptsOrder] = useState()
  const [delivery, setDelivery] = useState();
  const [salesclosingchannel, setSalesclosingchannel] = useState();
  const [brands,setBrands] = useState();
  const [categories,setCategories] = useState();
  const [isEditOpen,setIsEditOpen] = useState(false);
  const searchInput = useRef(null);

  const getOrders = async () => {
    await getDocs(
      query(collection(querydb, "orders"), orderBy("dateStart", "desc"))
    ).then((res) => {
      setData(mapDocs(res));
    },(error) => {
      console.log(error);
    });
  };

  const getProducts = async (order) => {
    setDetail(order.products);
  };

  useEffect(() => {
    setTimeout(async() => {
      setRole(await decrypt(localStorage.getItem("role")));
    },1000);
    getOrders();
    fetchData(querydb,collections.couriers,setCouriers);
    fetchData(querydb,collections.delivery_points,setDelivery);
    fetchData(querydb,collections.closing_channels,setSalesclosingchannel);
    fetchData(querydb,collections.brands,setBrands);
    fetchData(querydb,collections.categories,setCategories);
    // eslint-disable-next-line
  },[querydb]);

  const cancel = () => {
    form.resetFields();
  };

  const selectOrder = (record) => {
    setOrder(null);
    setOrder(record);
    setTimeout(async() => {
      setIsEditOpen(true);
    },2000);
  }

  const selectDetail = async (data,mode) => {
    await getProducts(data);
    setOrder(null);
    setOrder(data);
    if(mode === "modal"){
      setOpenDetail(true);
    }
  };

  const selectReceipts = async (order) => {
    setReceipts(order.fileImage);
    setOpenReceipt(true);
  };

  const selectReceiptsOrder = async (order) => {
    setReceiptsOrder(order.orderImage);
    setOpenReceiptOrder(true);
  };

  const [sizeWindow, setSizeWindow] = useState(true);
  useEffect(() => {
    window.innerWidth > 1000 ? setSizeWindow(true) : setSizeWindow(false);
  }, []);

  const contentDataOrder = (data) => (
    <Descriptions
      bordered
      size={"small"}
      style={{
        width: 500,
      }}
    >
      <Descriptions.Item label="Nombre Cliente" span={4}>
        {data.customerName}
      </Descriptions.Item>
      <Descriptions.Item label="Telefono" span={4}>
        {data.phoneNumber}
      </Descriptions.Item>
      <Descriptions.Item label="Dirección" span={4}>
        {data.address}
      </Descriptions.Item>
      <Descriptions.Item label="Referencia" span={4}>
        {data.reference || ""}
      </Descriptions.Item>
      <Descriptions.Item label="Datos de entrega" span={4}>
        {data.remarks}
      </Descriptions.Item>
      <Descriptions.Item label="Pago adelantado" span={4}>
        {data.advanceDelivery.toFixed(2)}
      </Descriptions.Item>
      <Descriptions.Item label="Pago pendiente" span={4}>
        {data.payable.toFixed(2)}
      </Descriptions.Item>
      <Descriptions.Item label="Distrito">
        {data.district}
      </Descriptions.Item>
    </Descriptions>
  );

  const [search, setSearch] = useState("");
  const [searchedCol, setSearchedCol] = useState("");
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearch("");
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearch(selectedKeys[0]);
    setSearchedCol(dataIndex);
  };
  
  const getColSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar por ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reiniciar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearch(selectedKeys[0]);
              setSearchedCol(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#189Off" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => 
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedCol === dataIndex ? (
        <HighLighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[search]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Serial",
      dataIndex: "serial",
      key: "serial",
      width: 80,
      fixed: sizeWindow ? "left" : false,
      ...getColSearchProps("serial"),
    },
    {
      title: "Vendedor",
      dataIndex: "seller",
      key:"seller",
      width: 160,
      ...getColSearchProps("seller"),
    },
    {
      title: "Cliente",
      dataIndex: "customerName",
      key:"customerName",
      width: 300,
      ...getColSearchProps("customerName"),
    },
    {
      title: "Tipo de Cliente",
      dataIndex: "clienttype",
      key:"clienttype",
      width: 150,
    },
    {
      title: "Telefono",
      dataIndex: "phoneNumber",
      key:"phoneNumber",
      width: 130,
      ...getColSearchProps("phoneNumber"),
    },
    {
      title: "Cta. instagram",
      dataIndex: "instagram",
      key:"instagram",
      width: 160,
      ...getColSearchProps("instagram"),
    },
    {
      title: "Provincia",
      dataIndex: "province",
      key: "province",
      filters:data && data.length ? [...new Map(data.map(item => [item.province,item])).values()].map((order) => {
        return {
          text:order.province,
          value:order.province.toUpperCase()
        }
      }).sort((a,b) => a.text.localeCompare(b.text)) : null,
      onFilter:(value,record) => record.province.toLowerCase() === value.toLowerCase(),
      width: 150,
    },
    {
      title: "Distrito",
      dataIndex: "district",
      key:"district",
      filters:data && data.length ? [...new Map(data.map(item => [item.district,item])).values()].map((order) => {
        return {
          text:order.district,
          value:order.district.toUpperCase()
        }
      }).sort((a,b) => a.text.localeCompare(b.text)) : null,
      onFilter:(value,record) => record.district.toLowerCase() === value.toLowerCase(),
      width: 210,
    },
    {
      title: "Tipo de Gestión",
      dataIndex: "managementtype",
      key:"managementtype",
      width: 150,
    },
    {
      title: "Tipo de Pago",
      dataIndex: "paymenttype",
      key:"paymenttype",
      width: 150,
    },
    {
      title: "Canal",
      dataIndex: "channel",
      key:"channel",
      width: 180,
      editable:checkAccess("editSaleChannels",role),
    },
    {
      title: "Canal de Venta",
      dataIndex: "salesclosingchannel",
      key:"salesclosingchannel",
      filters:
        salesclosingchannel && salesclosingchannel.length
          ? salesclosingchannel.map((channel) => {
              return {
                text: channel.name,
                value: channel.name.toUpperCase(),
              };
            })
          : null,
      onFilter: (value, record) =>
        record.salesclosingchannel.toLowerCase() === value.toLowerCase(),
      width: 150,
    },
    {
      title: "Datos de Pedido",
      dataIndex: "address",
      key:"address",
      width: 160,
      render: (_, record) => {
        return (
          <Popover
            content={contentDataOrder(record)}
            title="Datos de Pedido"
            trigger="click"
          >
            <Button className="btn-popover" type="link">Ver mas</Button>
          </Popover>
        );
      },
    },
    {
      title: "Comprobante",
      dataIndex: "fileImage",
      key:"fileImage",
      width: 130,
      filters:[
        {
          text:"Sin comprobante",
          value:false,
        },
        {
          text:"Con comprobante",
          value:true,
        }
      ],
      onFilter:(value,record) => {
        return Boolean(record.fileImage.length) === value;
      },
      render: (_, record) => {
        return !record.fileImage || !record.fileImage.length ? (
            <p>S/C</p>
        ) : (
          
            <Button type="link" onClick={() => selectReceipts(record)}>
              Visualizar
            </Button>
          
        );
      },
    },
    {
      title: "Monto Venta",
      dataIndex: "saleAmount",
      key:"saleAmount",
      width: 130,
      render: (_, record) => {
        return <span>${calculateOrder(record).saleAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Monto Envio",
      dataIndex: "shippingAmount",
      key:"shippingAmount",
      width: 130,
      render: (_, record) => {
        return <span>${record.shippingAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Pago adelantado",
      dataIndex: "advanceDelivery",
      key:"advanceDelivery",
      width: 150,
      render: (_, record) => {
        return <span>${record.advanceDelivery.toFixed(2)}</span>;
      },
    },
    {
      title: "Pago pendiente",
      dataIndex: "payable",
      key:"payable",
      width: 150,
      render: (_, record) => {
        return <span>${calculateOrder(record).payableAmount.toFixed(2)}</span>;
      },
    },
    {
      title: "Fecha Pedido",
      dataIndex: "dateStart",
      key:"dateStart",
      width: 120,
      render: (_, record) => {
        return (
          <>
            {typeof record.dateStart !== "string" ? (
              <span>{formatTimestamp(record.dateStart)}</span>
            ) : null}
          </>
        );
      },
    },
    {
      title: "Fecha Entrega",
      dataIndex: "dateEnd",
      key:"dateEnd",
      width: 130,
      render: (_, record) => {
        return (
          <>
            {record.dateEnd && typeof record.dateEnd !== "string" ? (
              <span>{formatTimestamp(record.dateEnd)}</span>
            ) : null}
          </>
        );
      },
    },
    {
      title: "Entrega",
      dataIndex: "delivery",
      key:"delivery",
      width: 200,
      filters:
        delivery && delivery.length
          ? delivery.map((item) => {
              return {
                text: item.name,
                value: item.name.toUpperCase(),
              };
            })
          : null,
      onFilter: (value, record) => record.delivery.toLowerCase() === value.toLowerCase(),
    },
    {
      title: "Foto pedido",
      dataIndex: "orderImage",
      key: "orderImage",
      width: 150,
      editable: true,
      filters: [
          {
              text: "Sin foto",
              value: false,
          },
          {
              text: "Con foto",
              value: true,
          }
      ],
      onFilter: (value, record) => {

          if (record.orderImage && typeof record.orderImage.length !== 'undefined') {
              return Boolean(record.orderImage.length) === value;
          }

          return value === false;
      },
      render: (_, record) => {
          return !record.orderImage || !record.orderImage.length ? (
              <p>S/F</p>
          ) : (
              <Button type="link" onClick={() => selectReceiptsOrder(record)}>
                  Visualizar
              </Button>
          );
      },
    },  
    {
      title: "Productos",
      dataIndex: "products",
      key:"products",
      width: 130,
      render: (_, record) => {
        return (
          <div>
            <Button type="link" onClick={() => selectDetail(record,"modal")}>
              Ver Productos
            </Button>
          </div>
        );
      },
    },
    {
      title: "Observaciones",
      dataIndex: "comments",
      key:"comments",
      width: 300,
    },
    {
      title: "Courier",
      dataIndex: "courier",
      key:"courier",
      width: 130,
      filters: 
        couriers && couriers.length 
          ? couriers.map((courier) => {
            return{
              text:courier.name,
              value:courier.name.toUpperCase()
            }
          }) : null,
      onFilter: (value,record) => record.courier.toLowerCase() === value.toLowerCase(),
      fixed: sizeWindow ? "right" : false,
    },
    {
      title: "Status",
      dataIndex: "status",
      key:"status",
      width: 150,
      fixed: sizeWindow ? "right" : false,
      filters: Object.keys(statusList).map((status) => {
        return {
          text: status,
          value: status,
        };
      }),
      onFilter: (value, record) => {
        return record.status.toLowerCase() === value.toLowerCase();
      },
      render: (_, record) => {
        return (
          <>
            {statusList[record.status] ? (
              <Tag color={statusList[record.status].color}>{record.status}</Tag>
            ) : null}
          </>
        );
      },
    },
    {
      title: "Accion",
      dataIndex: "operation",
      key:"operation",
      width: 100,
      fixed: sizeWindow ? "right" : false,
      render: (_, record) => {
        return(
          <div>
            <Button type="link" onClick={() => selectOrder(record)}>
              <EditOutlined/>
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <>
        {data === undefined || data.length === 0 ? (
          <p>Cargando pedidos....</p>
        ) : (
          <Table
            bordered
            dataSource={data}
            columns={columns}
            rowClassName="editable-row"
            pagination={{
              onChange: cancel,
            }}
            scroll={{
              x: 1300,
              y: 500,
            }}
          />
        )}
      {order && order.products && order.products.length ? 
      <ItemsView
      isModalOpen={openDetail}
      setIsModalOpen={setOpenDetail}
      detail={detail}
      order={order}
      brands={brands}
      categories={categories}
      updateItems={getProducts}
      updateOrder={getOrders}
      role={role}
      setOrder={setOrder}
      products={order.products}
      /> : null}
      <EditOrder
        record={order}
        editIsOpen={isEditOpen}
        setIsEditOpen={setIsEditOpen}
        updateOrder={getOrders}
        role={role}
        setOrder={setOrder}
      />
      <Gallery
        images={receipts}
        isModalOpen={openReceipt}
        setIsModalOpen={setOpenReceipt}
      />
      <Gallery
        images={receiptOrder}
        isModalOpen={openReceiptOrder}
        setIsModalOpen={setOpenReceiptOrder}
      />
    </>
  );
};